import { isCancel, CancelToken } from 'axios';
import { debounce } from 'lodash';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const subtractTwoArrays = (arr1, arr2) =>
  arr1.filter((a) => !arr2.map((b) => b.label).includes(a.label));

export const sortedObjectsInArray = (object) =>
  object.sort((a, b) => a.label.localeCompare(b.label));

export const makeFetchTerm = ({
  url,
  params,
  delay = 500,
  client = axios,
  paramsTransformer = ({ inputValue, params }) => ({
    ...params,
    term: inputValue || params.term,
  }),
}) => {
  let cancelToken = null;

  return debounce((inputValue, callback) => {
    // Cancel current request if we do another request
    if (cancelToken) {
      cancelToken.cancel();
    }

    cancelToken = CancelToken.source('Request canceled');

    client
      .get(url, {
        cancelToken: cancelToken.token,
        params: paramsTransformer({ inputValue, params }),
      })
      .then(({ data }) => {
        const items = data?.data || data;

        callback(
          items.map((d) => ({
            label: d.name,
            value: d.id,
            data: d,
          })),
        );
      })
      .catch((err) => {
        if (isCancel(err)) {
          return err.message;
        }

        return err;
      });
  }, delay);
};
